import PropTypes from "prop-types";
import {greyishBlue100} from "assets/jss/main";

import ChevronIcon from "./ChevronIcon";

OptionValueSelect.propTypes = {
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func,
};

const optionValues = ["couleur", "taille", "genre", "matière", "coupe"];

function OptionValueSelect({value, onChange = () => {}}) {
    return (
        <div style={{position: "relative", display: "inline-flex", alignItems: "center"}}>
            <select
                value={value}
                onChange={(e) => onChange(e.target.value)}
                style={{
                    appearance: "none",
                    WebkitAppearance: "none",
                    padding: "8px 36px 8px 14px",
                    borderRadius: "10px",
                    border: `1px solid ${greyishBlue100}`,
                    backgroundColor: "#ffffff",
                    fontSize: "14px",
                    color: "#374151",
                    cursor: "pointer",
                    fontFamily: "inherit",
                    outline: "none",
                    minWidth: "140px",
                }}
            >
                {optionValues.map((opt) => (
                    <option key={opt} value={opt}>{opt}</option>
                ))}
            </select>
            <div style={{position: "absolute", right: "12px", pointerEvents: "none"}}>
                <ChevronIcon/>
            </div>
        </div>
    );
}

export default OptionValueSelect;
